function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { GuestAgeCategory } from "@custom/schema";
export var apiBaseUrl = "https://api.camping.care/v3";
// This key is exposed from client to server, no need to use env var here.
export var apiKey = "pub_bGl2ZS1hZG1fMjIyY2I0YjNlOWQwNGJiN2JhZjg4M2U2OTkyMTQ4ZjMtdXNyXzJSbjVGVFN4TXpnOFJ5NHpmQ1FSN3doY296RTMtRXdXWGJkU2tNUmRHQkM0ODlsRWVhS1lKcllyMDlPclgtYXBpXzBmNjNlZDRiYmI4NjQ1ZWY4ZjgyNDI0ODk2MDA1YjEy";
var bookingBaseUrl = "https://booking.camping.care";
var guestsAgeCategoryMap = {
    adults: 18,
    young_adults: 16,
    children: 11,
    young_children: 4
};
var guestAgeToBirthdate = function(age) {
    //get the birth year
    var birthYear = new Date().getFullYear() - (age !== null && age !== void 0 ? age : 0);
    return "".concat(birthYear, "-01-01");
};
var Cache = /*#__PURE__*/ function() {
    "use strict";
    function Cache() {
        var ttlMinutes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 5;
        _class_call_check(this, Cache);
        _define_property(this, "cache", new Map());
        _define_property(this, "ttl", void 0);
        this.ttl = ttlMinutes * 60 * 1000; // Convert minutes to milliseconds
    }
    _create_class(Cache, [
        {
            key: "set",
            value: function set(key, value) {
                this.cache.set(key, {
                    data: value,
                    timestamp: Date.now()
                });
            }
        },
        {
            key: "get",
            value: function get(key) {
                var entry = this.cache.get(key);
                if (!entry) return null;
                var isExpired = Date.now() - entry.timestamp > this.ttl;
                if (isExpired) {
                    this.cache.delete(key);
                    return null;
                }
                return entry.data;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.cache.clear();
            }
        }
    ]);
    return Cache;
}();
// Initialize cache with 5 minutes TTL
var accommodationCache = new Cache(5);
// https://developer.camping.care/docs/tutorials/accommodation-search/
export function getCampingCareAccommodations(apiKey, variables) {
    return _getCampingCareAccommodations.apply(this, arguments);
}
function _getCampingCareAccommodations() {
    _getCampingCareAccommodations = _async_to_generator(function(apiKey, variables) {
        var _variables_input_sorts, cacheKey, cachedData, apiEndpoint, apiUrl, _ref, data, errors;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    // Generate cache key based on search parameters
                    cacheKey = JSON.stringify({
                        offset: variables.input.offset,
                        limit: variables.input.limit,
                        arrival: variables.input.arrival,
                        departure: variables.input.departure,
                        type: variables.input.type,
                        guests: variables.input.guests,
                        sorts: variables.input.sorts,
                        campsiteId: variables.input.campsiteId,
                        accommodationId: variables.input.accommodationId
                    });
                    // Check cache first
                    cachedData = accommodationCache.get(cacheKey);
                    if (cachedData) {
                        return [
                            2,
                            cachedData
                        ];
                    }
                    apiEndpoint = "".concat(apiBaseUrl, "/accommodations/search");
                    apiUrl = new URL(apiEndpoint);
                    if (variables.input.accommodationId) {
                        apiUrl.searchParams.set("accommodation_id", variables.input.accommodationId.toString());
                    }
                    apiUrl.searchParams.set("offset", variables.input.offset.toString());
                    apiUrl.searchParams.set("limit", variables.input.limit.toString());
                    apiUrl.searchParams.set("arrival", variables.input.arrival);
                    apiUrl.searchParams.set("departure", variables.input.departure);
                    apiUrl.searchParams.set("type", JSON.stringify(variables.input.type));
                    apiUrl.searchParams.set("age_table_categories", JSON.stringify(variables.input.guests));
                    // filter out non available results
                    apiUrl.searchParams.set("stock", JSON.stringify({
                        stock: 1,
                        operator: "GTE"
                    }));
                    (_variables_input_sorts = variables.input.sorts) === null || _variables_input_sorts === void 0 ? void 0 : _variables_input_sorts.forEach(function(sort, index) {
                        if (sort) {
                            apiUrl.searchParams.set("sorts[".concat(index, "][column]"), sort === null || sort === void 0 ? void 0 : sort.column);
                            apiUrl.searchParams.set("sorts[".concat(index, "][order]"), sort === null || sort === void 0 ? void 0 : sort.order);
                        }
                    });
                    return [
                        4,
                        fetch(apiUrl, {
                            method: "GET",
                            headers: {
                                Authorization: "Bearer ".concat(apiKey),
                                Accept: "application/json",
                                "X-Admin-Id": variables.input.campsiteId
                            }
                        })
                    ];
                case 1:
                    return [
                        4,
                        _state.sent().json()
                    ];
                case 2:
                    _ref = _state.sent(), data = _ref.data, errors = _ref.errors;
                    if (errors) {
                        throw errors;
                    }
                    // Cache the successful response
                    accommodationCache.set(cacheKey, data);
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return _getCampingCareAccommodations.apply(this, arguments);
}
//based on https://developer.camping.care/docs/booking-engine/parameters
export var getBookingURL = function(param) {
    var accommodationId = param.accommodationId, view = param.view, category = param.category, arrival = param.arrival, departure = param.departure, campsiteSlug = param.campsiteSlug, guests = param.guests;
    var url = new URL("".concat(bookingBaseUrl, "/").concat(campsiteSlug));
    if (view) url.searchParams.set("view", view);
    if (accommodationId) {
        url = new URL("".concat(bookingBaseUrl, "/").concat(campsiteSlug, "/accommodations/").concat(accommodationId));
        // Camping.care still uses the query string parameter even
        // if it's set in the route.
        url.searchParams.set("accommodation", accommodationId.toString());
    }
    if (category) url.searchParams.set("category", category);
    if (arrival) url.searchParams.set("arrival", arrival);
    if (departure) url.searchParams.set("departure", departure);
    if (guests) {
        var birthdates = guests.map(function(guest) {
            return {
                amount: guest.count,
                birthdate: guestAgeToBirthdate(guest.age)
            };
        });
        url.searchParams.set("birthdates", JSON.stringify(birthdates));
    }
    return url.toString();
};
export function accommodationSearchExecutor(apiKey) {
    return function() {
        var _ref = _async_to_generator(function(id, variables) {
            var campingCareData;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getCampingCareAccommodations(apiKey, variables)
                        ];
                    case 1:
                        campingCareData = _state.sent();
                        if (!campingCareData) {
                            return [
                                2,
                                {
                                    accommodationSearch: {
                                        results: []
                                    }
                                }
                            ];
                        }
                        return [
                            2,
                            {
                                accommodationSearch: {
                                    results: campingCareData.map(function(item) {
                                        var _item_name_translations_variables_input_locale, _item_description_translations_variables_input_locale;
                                        var name = ((_item_name_translations_variables_input_locale = item.name_translations[variables.input.locale]) === null || _item_name_translations_variables_input_locale === void 0 ? void 0 : _item_name_translations_variables_input_locale.description) || item.name;
                                        var description = ((_item_description_translations_variables_input_locale = item.description_translations[variables.input.locale]) === null || _item_description_translations_variables_input_locale === void 0 ? void 0 : _item_description_translations_variables_input_locale.description) || item.description;
                                        return {
                                            id: item.id,
                                            numericId: item.numeric_id,
                                            name: name,
                                            description: description,
                                            image: item.thumbnail,
                                            priceTotal: item.price_total,
                                            detailsUrl: getBookingURL({
                                                departure: variables.input.departure,
                                                arrival: variables.input.arrival,
                                                campsiteSlug: variables.input.campsiteSlug,
                                                guests: variables.input.guests.map(function(guest) {
                                                    var _guest_id, _guestsAgeCategoryMap_, _guest_count;
                                                    return {
                                                        age: (_guestsAgeCategoryMap_ = guestsAgeCategoryMap[(_guest_id = guest.id) !== null && _guest_id !== void 0 ? _guest_id : GuestAgeCategory.Adults]) !== null && _guestsAgeCategoryMap_ !== void 0 ? _guestsAgeCategoryMap_ : 0,
                                                        count: (_guest_count = guest.count) !== null && _guest_count !== void 0 ? _guest_count : 0
                                                    };
                                                }),
                                                accommodationId: item.numeric_id,
                                                view: "accommodation"
                                            }),
                                            reserveUrl: getBookingURL({
                                                departure: variables.input.departure,
                                                arrival: variables.input.arrival,
                                                campsiteSlug: variables.input.campsiteSlug,
                                                guests: variables.input.guests.map(function(guest) {
                                                    var _guest_id, _guestsAgeCategoryMap_, _guest_count;
                                                    return {
                                                        age: (_guestsAgeCategoryMap_ = guestsAgeCategoryMap[(_guest_id = guest.id) !== null && _guest_id !== void 0 ? _guest_id : GuestAgeCategory.Adults]) !== null && _guestsAgeCategoryMap_ !== void 0 ? _guestsAgeCategoryMap_ : 0,
                                                        count: (_guest_count = guest.count) !== null && _guest_count !== void 0 ? _guest_count : 0
                                                    };
                                                }),
                                                accommodationId: item.numeric_id,
                                                view: "cart"
                                            }),
                                            availableStock: item.available_stock
                                        };
                                    })
                                }
                            }
                        ];
                }
            });
        });
        return function(id, variables) {
            return _ref.apply(this, arguments);
        };
    }();
}
